module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('menu-openstatehandler'), _vm._v(" "), _c('menu-fullstatehandler'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu-overlay"
    },
    on: {
      "click": _vm.closeNavMenu
    }
  }), _vm._v(" "), _c('nav-menu'), _vm._v(" "), _c('main-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23599c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 456
// module chunks = 2